import { render, staticRenderFns } from "./tasks.vue?vue&type=template&id=749488fd&"
import script from "./tasks.vue?vue&type=script&lang=js&"
export * from "./tasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('749488fd')) {
      api.createRecord('749488fd', component.options)
    } else {
      api.reload('749488fd', component.options)
    }
    module.hot.accept("./tasks.vue?vue&type=template&id=749488fd&", function () {
      api.rerender('749488fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/tabs/tasks.vue"
export default component.exports